import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type ManageMessagesProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function ManageMessagesPage({ children, ...props }: ManageMessagesProps) {
  return (
    <MarkdownPage group={"announces"} message={"post"} isEditable={true}></MarkdownPage>
  )
}
